import { AnexoSalaModel, ListasSalaModel, SalaModel } from '@/models/gestao/sala/sala.model';
import api from '@/services/axios/api';
import { AxiosResponse } from 'axios';
import { DataSource, FiltrosModel } from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import { RegisterOutput } from '@/models/register-output';
import { useStore } from '@/store';

/** Os dados do formulário de anexo (o arquivo vai à parte). */
export interface EnviarAnexoSalaModel {
  descricao: string;
  tipoDocumento: number;
  /** AAAA-MM-DD, como sai do `<input type="date">`. */
  dataDocumento: string;
}

class SalaService {
  dadosIndexPaginado(
    pagina: number,
    itensPorPagina: number,
    filters: FiltrosModel[],
  ): Promise<AxiosResponse<DataSource<SalaModel>>> {
    const gesEscolaId = useStore().getters.getCodigoEscola;
    return api.post<DataSource<SalaModel>>(
      '/Sala/RetornoPaginado',
      {
        rowsPerPage: itensPorPagina,
        pageNumber: pagina,
        filters: filters,
      },
      {
        params: {
          GesEscolaId: gesEscolaId,
        },
      },
    );
  }

  inserirAtualizar(sala: SalaModel): Promise<AxiosResponse<RegisterOutput>> {
    return api.post('/Sala', sala);
  }

  remover(id: number): Promise<AxiosResponse> {
    return api.delete('/Sala/' + id);
  }

  async get(id: number): Promise<SalaModel | null> {
    const result = await api.get<SalaModel>(`/Sala/${id.toString()}`);
    // 204 (sala não encontrada) chega com corpo vazio.
    return result.data && typeof result.data === 'object' ? result.data : null;
  }

  /** Formas de ocupação e tipos de documento (listas fixas da API). */
  async listas(): Promise<ListasSalaModel> {
    const { data } = await api.get<ListasSalaModel>('/Sala/Listas');
    return {
      formasOcupacao: data?.formasOcupacao ?? [],
      tiposDocumento: data?.tiposDocumento ?? [],
    };
  }

  async listarAnexos(salaId: number): Promise<AnexoSalaModel[]> {
    const { data } = await api.get<AnexoSalaModel[]>(`/Sala/${salaId}/Anexos`);
    return Array.isArray(data) ? data : [];
  }

  async enviarAnexo(salaId: number, dados: EnviarAnexoSalaModel, arquivo: File): Promise<AnexoSalaModel> {
    const formulario = new FormData();
    formulario.append('descricao', dados.descricao);
    formulario.append('tipoDocumento', String(dados.tipoDocumento));
    formulario.append('dataDocumento', dados.dataDocumento);
    formulario.append('file', arquivo);

    const { data } = await api.post<AnexoSalaModel>(`/Sala/${salaId}/Anexos`, formulario, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  }

  async removerAnexo(salaId: number, anexoId: number): Promise<void> {
    await api.delete(`/Sala/${salaId}/Anexos/${anexoId}`);
  }

  async DropDownList(gesEscolaId?: number | null): Promise<TextoValor[]> {
    const endpoint = '/Sala/DropDownList';
    const codigoEscolaStore = useStore().getters.getCodigoEscola;
    const codigoEscola = Number(gesEscolaId ?? codigoEscolaStore ?? 0);
    const result = await api.get(endpoint, {
      params: {
        GesEscolaId: codigoEscola,
      },
    });
    // Mapeando os dados para o formato TextoValor
    return result.data.map((item: any) => ({
      valor: item.valor,
      texto: item.texto,
    }));
  }
}
export default new SalaService();
